module.exports = __webpack_public_path__ + "img/instagram-icon.5e5cbee7.svg";